import React from 'react';
import { X, Calendar, AlertTriangle } from 'lucide-react';
import { Modal } from '../ui/Modal';

interface ModalFechasFaltasProps {
  isOpen: boolean;
  onClose: () => void;
  fechasFaltas: string[];
  nombreJugador: string;
  temporadaNombre: string;
}

/**
 * Modal que muestra las fechas específicas donde un jugador faltó a entrenamientos
 */
export const ModalFechasFaltas: React.FC<ModalFechasFaltasProps> = ({
  isOpen,
  onClose,
  fechasFaltas,
  nombreJugador,
  temporadaNombre
}) => {
  /**
   * Formatea una fecha ISO a formato legible
   */
  const formatearFecha = (fechaISO: string): string => {
    const fecha = new Date(fechaISO);
    return fecha.toLocaleDateString('es-ES', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <div className="bg-secondary-800 rounded-lg shadow-xl max-h-[80vh] overflow-hidden border border-secondary-700">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-secondary-700">
          <div className="flex items-center space-x-2">
            <AlertTriangle className="w-5 h-5 text-error" />
            <h2 className="text-lg font-semibold text-secondary-50">
              Faltas de Asistencia
            </h2>
          </div>
          <button
            onClick={onClose}
            className="p-1 hover:bg-secondary-700 rounded-full transition-colors"
          >
            <X className="w-5 h-5 text-secondary-400" />
          </button>
        </div>

        {/* Content */}
        <div className="p-4">
          <div className="mb-4">
            <p className="text-sm text-secondary-300">
              <span className="font-medium text-secondary-50">{nombreJugador}</span> - {temporadaNombre}
            </p>
            <p className="text-sm text-secondary-400 mt-1">
              Total de faltas: <span className="font-medium text-error">{fechasFaltas.length}</span>
            </p>
          </div>

          {/* Lista de fechas */}
          <div className="max-h-60 overflow-y-auto">
            {fechasFaltas.length === 0 ? (
              <div className="text-center py-8">
                <Calendar className="w-12 h-12 text-secondary-600 mx-auto mb-2" />
                <p className="text-secondary-400">No hay faltas registradas</p>
              </div>
            ) : (
              <div className="space-y-2">
                {fechasFaltas.map((fecha, index) => (
                  <div
                    key={index}
                    className="flex items-center space-x-3 p-3 bg-error/10 rounded-lg border border-error/20"
                  >
                    <Calendar className="w-4 h-4 text-error flex-shrink-0" />
                    <span className="text-sm text-secondary-200 capitalize">
                      {formatearFecha(fecha)}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="p-4 border-t border-secondary-700">
          <button
            onClick={onClose}
            className="w-full bg-secondary-700 hover:bg-secondary-600 text-secondary-100 font-medium py-2 px-4 rounded-lg transition-colors"
          >
            Cerrar
          </button>
        </div>
      </div>
    </Modal>
  );
};